var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.2505C16.2802 21.2505 19.75 17.5005 19.75 13.0005C19.75 7.83347 15.1368 4.17163 13.2786 2.90627C12.853 2.6164 12.2906 2.74183 11.9942 3.16301L9.58196 6.59127C9.22547 7.09791 8.49654 7.15961 8.05707 6.72298C7.66693 6.33535 7.03099 6.33117 6.68083 6.75527C5.06028 8.71804 4.25 11.1619 4.25 13.0005C4.25 17.5005 7.71979 21.2505 12 21.2505ZM12 21.2505C13.6569 21.2505 15 19.7173 15 17.8261C15 15.7429 13.3369 14.2253 12.4872 13.5858C12.1953 13.3661 11.8047 13.3661 11.5128 13.5858C10.6631 14.2253 9 15.7429 9 17.8261C9 19.7173 10.3431 21.2505 12 21.2505Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire2);
export default __webpack_public_path__ + "static/media/fire-2.97d7a7f83b801d95b67deced10ad744b.svg";
export { ForwardRef as ReactComponent };